import { fetchSkywalkerClientData } from '@growth/api-calls';

var getSequenceData = function getSequenceData(res) {
  var _res$sequenceData, _res$sequenceData$BAS, _res$sequenceData$BAS2;

  return (res == null ? void 0 : (_res$sequenceData = res.sequenceData) == null ? void 0 : (_res$sequenceData$BAS = _res$sequenceData.BASE_SHEET) == null ? void 0 : (_res$sequenceData$BAS2 = _res$sequenceData$BAS.cardSequence) == null ? void 0 : _res$sequenceData$BAS2.data) || [];
};

var getData = function getData(res) {
  var _res$data, _res$data$BASE_SHEET;

  return (res == null ? void 0 : (_res$data = res.data) == null ? void 0 : (_res$data$BASE_SHEET = _res$data.BASE_SHEET) == null ? void 0 : _res$data$BASE_SHEET.cardData) || {};
};

var getGlobalData = function getGlobalData(res) {
  var _res$data2, _res$data2$BASE_SHEET;

  return (res == null ? void 0 : (_res$data2 = res.data) == null ? void 0 : (_res$data2$BASE_SHEET = _res$data2.BASE_SHEET) == null ? void 0 : _res$data2$BASE_SHEET.apiData) || {};
};

var skywalkerResponseFormatter = function skywalkerResponseFormatter(resp) {
  return {
    sequence: getSequenceData(resp),
    data: getData(resp),
    globalData: getGlobalData(resp)
  };
};

var getSkywalkerData = function getSkywalkerData(opts) {
  var _config$apiHeaders;

  var extraReqBody = opts.extraReqBody,
      fetcherConfig = opts.fetcherConfig;
  var config = fetcherConfig;
  var endpointPath = config == null ? void 0 : config.apiPath;
  var osHeader = config == null ? void 0 : (_config$apiHeaders = config.apiHeaders) == null ? void 0 : _config$apiHeaders.os;
  var headers = {
    os: osHeader
  };
  return fetchSkywalkerClientData({
    endpointPath: endpointPath,
    extraReqBody: extraReqBody
  }, headers).then(function (res) {
    return skywalkerResponseFormatter(res);
  });
};

export { getSkywalkerData, skywalkerResponseFormatter };
